import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDashboardData } from "../../../features/dashboard/services/dashboardService";

const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getCurrentMonthRange = () => {
  const now = new Date();
  return {
    startDate: formatLocalDate(new Date(now.getFullYear(), now.getMonth(), 1)),
    endDate: formatLocalDate(new Date(now.getFullYear(), now.getMonth() + 1, 0)),
  };
};

export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async ({ dateRange, documentType }, thunkAPI) => {
    const response = await fetchDashboardData(dateRange, documentType);
    // ✅ Extract payload from response if it exists
    return response.payload || response.data || response;
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    loading: false,
    error: null,
    data: null,
    period: "monthly", // <-- set default here
    dateRange: getCurrentMonthRange(), // { startDate, endDate }
    documentType: 'all', // all | invoice | ticket_de_caisse | sale_order
  },
  reducers: {
    setPeriod(state, action) {
      state.period = action.payload;
    },
    setDateRange(state, action) {
      state.dateRange = action.payload;
    },
    setDocumentType(state, action) {
      state.documentType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setPeriod, setDateRange, setDocumentType } = dashboardSlice.actions;
export default dashboardSlice.reducer;